const CognakMass=[
    // {
    //     id:1,
    //     title:"Реми Мартан VSOP (Франція) 1л",
    //     price:"3700 грн",
    //     src: require('../img/rmvsop.webp'),
    //     text:"50мл - 185 грн",
    // },
    // {
    //     id:2,
    //     title:"Старий Кахеті **** (Грузія) 0,5л",
    //     price:"620 грн",
    //     src: require('../img/sk4.webp'),
    //     text:"50мл - 62 грн",
    // },
    // {
    //     id:3,
    //     title:"Aznauri ***** (Грузія) 0,5л",
    //     price:"500 грн",
    //     src: require('../img/azn.webp'),
    //     text:"50мл - 50 грн",
    // },
    {
        id:4,
        title:"Хеннессі Very Special (Франція) 0,5л",
        price:"2800 грн",
        src: require('../img/henessi.png'),
        text:"50мл - 280 грн",
    },
    {
        id:5,
        title:"Коблево Резерв 5* (Україна) 0,5л",
        price:"650 грн",
        src: require('../img/koblevo.png'),
        text:"50мл - 65 грн",
    },
    {
        id:6,
        title:"Легенда Вірменії 4* (Грузія) 0,5л",
        price:"800 грн",
        src: require('../img/legenda.png'),
        text:"50мл - 80 грн",
    },
    {
        id:7,
        title:"Метакса 5 Зірок (Греція) 0,5л",
        price:"1250 грн",
        src: require('../img/metaxa.png'),
        text:"50мл - 125 грн",
    },
    {
        id:8,
        title:"Каноні 5 * (Грузія) 0,5л",
        price:"800 грн",
        src: require('../img/kanoni.png'),
        text:"50мл - 80 грн",
    },
    
]

export default CognakMass;